import { ReferrerType, VisitorType } from '@enums/visitor-identity';
import UniversalCookie from 'universal-cookie';

interface VisitorIdentity {
  visitorType: VisitorType;
  userId?: string;
  utmParams?: string;
  referrer?: string;
  referrerType?: ReferrerType;
  isTrustedReferrer?: boolean;
}

const cookies = new UniversalCookie();

export function getVisitorIdentityFromCookie(): VisitorIdentity | null {
  try {
    const cookieValue = cookies.get('visitor_identity');
    return typeof cookieValue === 'string' ? JSON.parse(cookieValue) : cookieValue ?? null;
  } catch {
    return null;
  }
}
